/**
 * `dismiss-amendment-signal` — an Admin dismisses a "possibly an amendment"
 * flag · CLM-118 (R-118-14, B13; DR-02).
 *
 * `POST /v1/contracts/{contract_key}/amendment-signal/dismiss`, gate
 * `admin:configure`. A contract is **flagged** when it is an agreement with no
 * `amends` and no `supersedes` edge, not `Superseded`, not already dismissed,
 * and either its file or folder name carries an amendment word
 * (`amendment_signal_name`) or the AI's reading named an agreement it amends or
 * replaces (`amends_reference` / `supersedes_reference`). Dismissing records
 * the time and the Admin on the row; `tg_contract_audit`'s `Update` row is the
 * audit, and its receipt is the response's `audit`. Linking the contract to its
 * agreement is CLM-120, not this.
 *
 * The flag never changes the type (the type rule ignores it).
 *
 * Out of scope is `404 contract_not_found`, never 403; a contract the flag
 * predicate does not select is `409 no_amendment_signal`. The request carries
 * nothing: the path names the contract, the session names the Admin.
 */
import { z } from 'zod';
import { ContractKeySchema, IsoTimestampUtcSchema } from '../primitives.js';
import { AuditReceiptSchema } from '../provenance.js';
/**
 * The path's `contract_key`, which the gateway merges into the request (the
 * `decide-contract-type` convention); the body is empty. `.strict()`: a client
 * cannot name the dismissing Admin or anything else.
 */
export const DismissAmendmentSignalRequestSchema = z.object({ contract_key: ContractKeySchema }).strict();
export const DismissAmendmentSignalResponseSchema = z
    .object({
    contract_key: ContractKeySchema,
    amendment_signal_dismissed_utc: IsoTimestampUtcSchema,
    /** The `0046` `Update` row the dismissal wrote. */
    audit: AuditReceiptSchema,
})
    .strict();
/** Why a dismissal is refused: the contract carries no live flag. */
export const DISMISS_AMENDMENT_SIGNAL_REFUSALS = ['no_amendment_signal'];
//# sourceMappingURL=dismiss-amendment-signal.js.map